module.exports = __webpack_public_path__ + "img/buttonicon1.e75d086f.png";